import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  OutboundSetupHelpCreate,
  OutboundPickListHelpCreate,
  OutboundNotesHelpCreate,
  OutboundSetupHelpEdit,
  OutboundPickListHelpEdit,
  OutboundDispatchHelpEdit,
  OutboundNotesHelpEdit,
  OutboundHistoryHelpEdit,
} from "./OutboundHelpComponents";

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const OutboundCreateHelp = (props) => {
  const classes = useStyles();

  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <OutboundSetupHelpCreate classes={classes} />;
    case "pickList":
      return <OutboundPickListHelpCreate classes={classes} />;
    case "notes":
      return <OutboundNotesHelpCreate classes={classes} />;
    default:
      return null;
  }
};

export const OutboundEditHelp = ({ bolData, ...props }) => {
  const classes = useStyles();
  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <OutboundSetupHelpEdit bolData={bolData} classes={classes} />;
    case "pickList":
      return <OutboundPickListHelpEdit classes={classes} />;
    case "dispatch":
      return <OutboundDispatchHelpEdit classes={classes} />;
    case "notes":
      return <OutboundNotesHelpEdit classes={classes} />;
    case "history":
      return <OutboundHistoryHelpEdit classes={classes} />;
    default:
      return null;
  }
};

// const Switch = props => {
//     const { test, children } = props
//     // filter out only children with a matching prop
//     return children.find(child => {
//       return child.props.value === test
//     })
// }

// const Sample = props => {
//     const someTest = true
//     return (
//       <Switch test={someTest}>
//         <div value={false}>Will display if someTest is false</div>
//         <div value={true}>Will display if someTest is true</div>
//       </Switch>
//     )
// }
